"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const HelpIconology_vue_1 = require("@/client/components/help/HelpIconology.vue");
const HelpPhases_vue_1 = require("@/client/components/help/HelpPhases.vue");
const HelpHotkeys_vue_1 = require("@/client/components/help/HelpHotkeys.vue");
const HelpRulebooks_vue_1 = require("@/client/components/help/HelpRulebooks.vue");
const HelpStandardProjects_vue_1 = require("@/client/components/help/HelpStandardProjects.vue");
const TABS = ['iconology', 'standard-projects', 'phases', 'hotkeys', 'rulebooks'];
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'Help',
    data() {
        return {
            currentPage: 'iconology',
        };
    },
    components: {
        HelpIconology: HelpIconology_vue_1.default,
        HelpPhases: HelpPhases_vue_1.default,
        HelpRulebooks: HelpRulebooks_vue_1.default,
        HelpStandardProjects: HelpStandardProjects_vue_1.default,
        HelpHotkeys: HelpHotkeys_vue_1.default,
    },
    mounted() {
        const hash = window.location.hash.replace('#', '');
        if (TABS.includes(hash)) {
            this.currentPage = hash;
        }
    },
    watch: {
        currentPage(newTab) {
            window.location.hash = newTab;
        },
    },
    methods: {
        setTab(tab) {
            this.currentPage = tab;
        },
        isOpen(tab) {
            return tab === this.currentPage;
        },
    },
});
